import { BaseFieldWidget, DefaultComparisonOperator, FormStringFieldSingleWidget, ModelFieldType, SPI, ViewMode, ViewType, Widget } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: ModelFieldType.String,
    name: 'meituanSkuId',
    model: 'deli.retail.RetailItemSku'
  })
)
export class FormStringSkuIdField extends FormStringFieldSingleWidget {
  @Widget.Reactive()
  public get disabled(): boolean {
    const superDisabled = super.disabled;

    if (superDisabled === true) {
      return true;
    }

    return !this.executeExpression<boolean>(this.getDsl().independentlyEditable as string);
  }
}
